import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const DebugDashboard: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  return (
    <div className='p-8 bg-gray-100 min-h-screen'>
      <h1 className='text-3xl font-bold mb-6'>Debug Dashboard</h1>

      <div className='bg-white p-6 rounded-lg shadow-md mb-6'>
        <h2 className='text-xl font-semibold mb-4'>Authentication Status</h2>
        <p>
          <strong>Is Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}
        </p>
        <p>
          <strong>User Role:</strong> {user?.role || 'None'}
        </p>
        <p>
          <strong>Synced:</strong> {user?.externalUserId ? 'Yes' : 'No'}
        </p>
        <p>
          <strong>User Email:</strong> {user?.email || 'None'}
        </p>
      </div>

      {user?.role === 'admin' ? (
        <div className='bg-green-100 p-6 rounded-lg'>
          <h2 className='text-xl font-semibold mb-4 text-green-800'>
            Admin Access Granted
          </h2>
          <p className='text-green-700'>You should see the admin dashboard.</p>

          {/* Simple sidebar test */}
          <div className='mt-6 flex'>
            <div className='w-60 bg-blue-500 text-white p-4 mr-4'>
              <h3 className='font-bold mb-4'>Test Sidebar</h3>
              <ul className='space-y-2'>
                <li className='bg-blue-600 p-2 rounded'>Dashboard</li>
                <li className='bg-blue-600 p-2 rounded'>Users</li>
                <li className='bg-blue-600 p-2 rounded'>Chats</li>
              </ul>
            </div>
            <div className='flex-1 bg-gray-50 p-4'>
              <h3 className='font-bold'>Main Content Area</h3>
              <p>This is where the admin content would appear.</p>
            </div>
          </div>
        </div>
      ) : (
        <div className='bg-red-100 p-6 rounded-lg'>
          <h2 className='text-xl font-semibold mb-4 text-red-800'>
            Admin Access Denied
          </h2>
          <p className='text-red-700'>
            You need admin privileges to see the dashboard.
          </p>
        </div>
      )}
    </div>
  );
};

export default DebugDashboard;
